import { motion } from "framer-motion"

const IconPlaceholder = ({ className, size = 32, fill = "currentColor", ...animations }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <motion.path
      {...animations}
      d="M20 4v16H4V4h16Zm-8 9.41L7.41 18h9.18L12 13.41Zm-6-6v9.18L10.59 12 6 7.41Zm12 0L13.41 12 18 16.59V7.41ZM16.59 6H7.41L12 10.59 16.59 6Z"
      fill={fill}
      stoke="none"
      fillRule="evenodd"
    />
  </svg>
)

export default IconPlaceholder
